module.exports = __webpack_public_path__ + "b45d7f364f6c56c99f4ed6e4336d28d3.svg";